export const iconFontAwesomeArrowsCircleArrowDown = (
	<i className="fa-solid fa-circle-arrow-down"></i>
);
